(function () {
    'use strict';

    angular.module("imApp").factory("collectionLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listCollectionLanguages: function (parms) {
                return $ihttp.post({
                    method: 1222,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1223,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
